import { resourceExplorerByCurrentIdSelector } from "../resource-explorer-by-id/resourceExplorerByCurrentIdSelector";
import { RootState } from "../../../store";

export const resourceExplorerNameSelector = (state: RootState) => {
  const resourceExplorer = resourceExplorerByCurrentIdSelector(state);

  return resourceExplorer?.name;
};
